import { render, staticRenderFns } from "./TermsDashboard.vue?vue&type=template&id=5df83011&scoped=true"
import script from "./TermsDashboard.vue?vue&type=script&lang=js"
export * from "./TermsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df83011",
  null
  
)

export default component.exports